<template>
  <div :class="isLeft ? 'floL' : 'floR'">
    <p
      class="fntH6 fntL bold marTML marBM"
      style="color:#2c2c2c;"
      :style="isLeft ? { width: '49%' } : null"
    >{{ getFullTextByType(participant) }}</p>
    <!-- 참여 여부 -->
    <div
      :class="isLeft ? 'NCAcmi_cont01-1' : 'NCAcmi_cont01-2'"
      class="padBM NCAcmi_lineBtm"
    >
      <p
        :class="{ moOnly: !isLeft }"
        class="fntP"
      >참여여부 <span class="ico-must-astar"></span></p>
      
      <div class="amway-theme" style="width:55%;">
        <div class="action NCAcmi_radioBtn radio-wrapper NCAcmi_cont01_radio">
          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              :name="`attendance-radio-${seq}`"
              class="amw-global-radio"
              value="Y"
              @change="selectAttendance"
              :checked="participant.attendance_yn === 'Y'"
              :disabled="!infoAvailable"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">참여</span>
          </label>

          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              :name="`attendance-radio-${seq}`"
              class="amw-global-radio"
              value="N"
              @change="selectAttendance"
              :checked="participant.attendance_yn === 'N'"
              :disabled="!infoAvailable"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">불참</span>
          </label>
        </div>
      </div>
    </div>

    <!-- 이름 -->
    <div
      :class="isLeft ? 'NCAcmi_cont01-1' : 'NCAcmi_cont01-2'"
      class="padBSM padTSM NCAcmi_cont01_input NCAcmi_lineBtm"
    >
      <label
        :for="`NCAcmi_name${seq}`"
        class="fntP"
        :class="{ moOnly: !isLeft }"
      >이름 <span class="ico-must-astar"></span></label>
      <input
        type="text"
        :id="`NCAcmi_name${seq}`"
        :name="`NCAcmi_name${seq}`"
        :value="participant.name"
        @input="inputName(seq, $event.target.value)"
        :disabled="disabledByType || disabledByAttendance || !infoAvailable"
        size="50"
        maxlength="50"
      />
    </div>

    <!-- ABO 번호 -->
    <div
      :class="isLeft ? 'NCAcmi_cont01-1 NCAcmi_cont01_input' : 'NCAcmi_cont01-2 NCAcmi_pc'"
      class="padBSM padTSM NCAcmi_lineBtm"
    >
      <template v-if="isLeft">
        <label
          :for="`NCAcmi_abo${seq}`"
          class="fntP"
        >ABO번호</label>
        <input
          type="text"
          :id="`NCAcmi_abo${seq}`"
          :name="`NCAcmi_abo${seq}`"
          :value="participant.abo_uid"
          disabled
        >
      </template>
    </div>

    <!-- 주민등록번호 -->
    <div
      :class="isLeft ? 'NCAcmi_cont01-1' : 'NCAcmi_cont01-2'"
      class="padBSM padTSM NCAcmi_lineBtm"
    >
      <label
        :for="`NCAcmi_personal01-${seq}`"
        :class="{ moOnly: !isLeft }"
        class="fntP"
        style="width:45%;"
      >주민등록번호 <span class="ico-must-astar"></span>
      </label>
      <em class="txtR" style="width:55%;"
      ><input
        type="number"
        :id="`NCAcmi_personal${seq}-1`"
        :name="`NCAcmi_personal${seq}-1`" 
        class="NCAcmi_num"
        style="width:45%"
        :value="participant.questions['Q014_1'].raw_data"
        @input="inputJuminNumber(seq, 'Q014_1', $event.target)"
        maxlength="6"
        :disabled="disabledByAttendance || !infoAvailable"
      /><span class="disIb txtC" style="width:10%;">-</span
      ><input
        type="number"
        :id="`NCAcmi_personal${seq}-2`"
        :name="`NCAcmi_personal${seq}-2`"
        class="NCAcmi_num"
        style="width:45%; -webkit-text-security: disc;"
        :value="participant.questions['Q014_2'].raw_data"
        @input="inputJuminNumber(seq, 'Q014_2', $event.target)"
        maxlength="7"
        :disabled="disabledByAttendance || !infoAvailable"
      /></em>
    </div>

    <!-- 배우자 참가 신청서 -->
    <SurveyAttachment
      v-if="existSpouse"
      :class="{ NCAcmi_blankR: participant.type !== 'S' }"
      class="padBSM padTSM NCAcmi_lineBtm"
      :participant="participant"
      :sq-code="'Q013'"
      :disabled="disabledByAttendance || !infoAvailable"
      :hide-btn="participant.type !=='S'"
      :is-left="isLeft"
    />

    <!-- 여권 사본 -->
    <SurveyAttachment
      :class="{ NCAcmi_last: participant.type === 'S' || (participant.type === 'P' && hideDocument) }"
      class="padBSM padTSM NCAcmi_file02-1_wrap"
      :participant="participant"
      :sq-code="'Q015'"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
    />

    <!-- 가족관계 증명서 -->
    <SurveyAttachmentCommon
      v-if="needFamilyRelationDocument"
      :class="{ NCAcmi_blankR: hideDocument }"
      class="padBSM padTSM NCAcmi_lineBtm"
      :sq-code="'Q012'"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :hide-btn="hideDocument"
      :height="!isLeft && hideDocument ? `198.19px` : null"
    >
      <template v-if="hideDocument && isLeft" #inner>
        <span
          v-html="questions['Q012'].alert_text"
          class="fntE pcOnly disBl"
          style="color:#d91734; padding-left: 0.6em;"
        ></span>
      </template>
      <template #outer>
        <p
          v-if="!hideDocument && isLeft"
          v-html="questions['Q012'].alert_text"
          class="marTS fntE"
          style="color:#d91734; padding-left: 0.6em;"
        ></p>
        <p
          v-if="!hideDocument && !isLeft"
          v-html="questions['Q012'].alert_text"
          class="marTS moOnly fntE"
          style="color:#d91734; padding-left: 0.6em;"
        ></p>
      </template>
    </SurveyAttachmentCommon>

    <!-- 안전확인 동의서 -->
    <SurveyAttachmentCommon
      :class="{ NCAcmi_blankR: hideDocument }"
      class="padBSM padTSM NCAcmi_lineBtm"
      :sq-code="'Q016'"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :hide-btn="hideDocument"
    />

    <!-- 초상권 확인 동의서 -->
    <SurveyAttachmentCommon
      :class="{ NCAcmi_blankR: hideDocument, 'NCAcmi_file02-1_wrap': needFamilyDocument }"
      class="padBSM padTSM"
      :sq-code="'Q017'"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :hide-btn="hideDocument"
    />

    <!-- 객실 추가 신청서 -->
    <SurveyAttachmentCommon
      v-if="needFamilyDocument"
      :class="hideDocument ? 'NCAcmi_cont01-2 NCAcmi_pc' : null"
      class="padBSM padTSM"
      :style="participant.type === 'P' && participant.type_seq === 1 && hideDocument ? { 'justify-content': 'flex-start' } : null"
      :sq-code="'Q018'"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :hide-btn="hideDocument"
    />
  </div>
</template>

<script>
import SurveyAttachment from './SurveyAttachment.vue'
import SurveyAttachmentCommon from './SurveyAttachmentCommon.vue'
import { mapGetters } from 'vuex'
import { CommonMethodMixin } from '../mixins'
import {
  SURVEY,
  COMMON_QUESTIONS,
  SET_ATTENDANCE,
  ATTENDING_LIST,
  INFO_AVAILABLE,
  SPOUSE_ATTENDANTS,
  MEMBER_ATTENDANTS,
  NEED_FAMILY_RELATION_DOCUMENT,
  NEED_FAMILY_DOCUMENT,
  SET_FAMILY_ATTENDANCE_YN,
  CLEAR_RESPONSE_DATA
} from '@/store/actions/survey'

export default {
  name: 'SurveyParticipant',
  mixins: [CommonMethodMixin],
  components: {
    SurveyAttachment,
    SurveyAttachmentCommon
  },
  props: {
    seq: {
      type: Number,
      required: true
    },
    participant: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapGetters(SURVEY, {
      attendingList: ATTENDING_LIST,
      questions: COMMON_QUESTIONS,
      infoAvailable: INFO_AVAILABLE,
      needFamilyRelationDocument: NEED_FAMILY_RELATION_DOCUMENT,
      needFamilyDocument: NEED_FAMILY_DOCUMENT,
      spouseAttendants: SPOUSE_ATTENDANTS,
      memberAttendants: MEMBER_ATTENDANTS,
    }),
    isLeft() {
      return this.seq % 2 === 0;
    },
    disabledByType() {
      return this.participant.type === 'E' || this.participant.type === 'P';
    },
    disabledByAttendance() {
      return !this.participant.attendance_yn || this.participant.attendance_yn === 'N';
    },
    isSole() {
      return this.participant.type === 'E';
    },
    existSpouse() {
      return this.spouseAttendants.length > 0;
    },
    existMember() {
      return this.memberAttendants.length > 0;
    },
    isFirstParty() {
      if(!this.existMember && this.participant.type === 'P' && this.participant.type_seq === 1) {
        return true;
      } else {
        const firstParty = this.attendingList.filter(attendant => attendant.type === 'P').sort((a, b) => a.type_seq - b.type_seq)[0];
        return firstParty ? (firstParty.type === this.participant.type && firstParty.type_seq === this.participant.type_seq) : false;
      }
    },
    hideDocument() {
      return !(this.isSole || this.isFirstParty);
    },
  },
  methods: {
    selectAttendance(e) {
      const attendance_yn = e.target.value;
      this.$store.commit(`${SURVEY}/${SET_ATTENDANCE}`, { idx: this.seq, attendance_yn });
      if(attendance_yn === 'N') {
        if(!this.existMember) {
          this.$store.commit(`${SURVEY}/${SET_FAMILY_ATTENDANCE_YN}`, attendance_yn);
        }
        this.$store.dispatch(`${SURVEY}/${CLEAR_RESPONSE_DATA}`, this.seq);
      }
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey2/components/SurveyParticipant.vue